"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5699],{

/***/ 48198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ CO_BRANDED_PARTNER_INFORMATION; }
/* harmony export */ });
/* harmony import */ var _usr_src_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71383);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68806);


var _templateObject;


var CO_BRANDED_PARTNER_INFORMATION = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_templateObject || (_templateObject = (0,_usr_src_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  query coBrandedPartnerInformation($input: CoBrandedPartnerInformationInput!) {\n    coBrandedPartnerInformation(input: $input) {\n      ... on CoBrandedPartnerInformationSuccess {\n        name\n        pricingPlan\n      }\n      ... on CoBrandedPartnerInformationError {\n        errors {\n          message\n        }\n      }\n    }\n  }\n"])));

/***/ }),

/***/ 29192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Footer_Footer; }
});

// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/@care/navigation/dist/components/HomePayVisitorFooter/HomePayVisitorFooter.js + 18 modules
var HomePayVisitorFooter = __webpack_require__(2551);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(18459);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Layout/Footer/Footer.tsx





var _ref = config_default()(),
    publicRuntimeConfig = _ref.publicRuntimeConfig;

var ABOUTUS_URL = publicRuntimeConfig.ABOUTUS_URL,
    HOMEPAY_URL = publicRuntimeConfig.HOMEPAY_URL,
    HOUSEHOLD_URL = publicRuntimeConfig.HOUSEHOLD_URL,
    NPR_URL = publicRuntimeConfig.NPR_URL,
    NTG_URL = publicRuntimeConfig.NTG_URL,
    RESOURCE_CENTER_CHILDCARE_URL = publicRuntimeConfig.RESOURCE_CENTER_CHILDCARE_URL,
    FOR_PARTNERS_URL = publicRuntimeConfig.FOR_PARTNERS_URL,
    PRIVACY_POLICY_URL = publicRuntimeConfig.PRIVACY_POLICY_URL,
    SITEMAP_URL = publicRuntimeConfig.SITEMAP_URL,
    SNC_URL = publicRuntimeConfig.SNC_URL,
    STATETAX_URL = publicRuntimeConfig.STATETAX_URL,
    TOS_URL = publicRuntimeConfig.TOS_URL;

var Footer = function Footer(_ref2) {
  var featured = _ref2.featured,
      _ref2$isMobile = _ref2.isMobile,
      isMobile = _ref2$isMobile === void 0 ? false : _ref2$isMobile;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(HomePayVisitorFooter/* default */.Z, {
    hideSocialLinks: true,
    isMobile: isMobile,
    featured: featured,
    footNotes: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "**Happiness Guarantee: We proudly stand behind the quality of our service. If you are unhappy with our service for any reason within the first 6 months after we activate your account, call our dedicated team of consultants at 1-888-273-3356 within that 6-month time period. We will then reimburse all HomePay fees paid by you prior to your call. A reimbursement may only be requested once under this guarantee, and cannot be used again if you reenroll. Reimbursement does not include fees for non-sufficient funds, credit card processing fees and payroll reversal fees. This Happiness Guarantee is valid for clients who pay HomePay directly for quarterly or monthly service fees. It is not valid for corporate clients including Care@Work and senior care agency clients."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "***Service Accuracy Guarantee: We guarantee (i) that your tax returns will be filed accurately and on time, and (ii) that your tax remittances will be paid on schedule if, in each of the foregoing cases, we receive your complete and accurate information by the end of the calendar quarter. If you incur monetary penalties from tax regulators due to our fault, and we are not successful in getting those amounts waived, we will at our discretion either pay those penalties on your behalf, or reimburse you for those amounts, in each case, excluding any other liability or the underlying tax obligation itself. We will not be at fault if we cannot collect the necessary amounts from your bank account or credit card on the day we request it. Please reference the Service Accuracy Guarantee by telephone at 888-273-3356 with respect to an error made during the period such recipient(s) were HomePay customers."
    })],
    linkColumns: [{
      groupTitle: 'About Homepay',
      links: [{
        label: 'About us',
        address: ABOUTUS_URL
      }, {
        label: 'Site map',
        address: SITEMAP_URL
      }, {
        label: 'Terms of use',
        address: TOS_URL
      }, {
        label: 'Privacy policy',
        address: PRIVACY_POLICY_URL
      }]
    }, {
      groupTitle: 'Tax & payroll service',
      links: [{
        label: 'Service & pricing',
        address: "".concat(HOMEPAY_URL).concat(constants/* ROUTING_PROPERTIES.productAndPricing.relativeURL */.ZY.productAndPricing.relativeURL)
      }, {
        label: 'Nanny',
        address: "".concat(HOMEPAY_URL).concat(constants/* ROUTING_PROPERTIES.productAndPricing.relativeURL */.ZY.productAndPricing.relativeURL)
      }, {
        label: 'Senior care',
        address: "".concat(HOMEPAY_URL).concat(constants/* ROUTING_PROPERTIES.seniorCare.relativeURL */.ZY.seniorCare.relativeURL)
      }, {
        label: 'Household workers',
        address: HOUSEHOLD_URL
      }, {
        label: 'For partners',
        address: FOR_PARTNERS_URL
      }, {
        label: 'For caregivers',
        address: "".concat(HOMEPAY_URL).concat(constants/* ROUTING_PROPERTIES.caregiver.relativeURL */.ZY.caregiver.relativeURL)
      }, {
        label: 'ProPortal',
        address: "".concat(HOMEPAY_URL).concat(constants/* ROUTING_PROPERTIES.proPortal.relativeURL */.ZY.proPortal.relativeURL)
      }]
    }, {
      groupTitle: 'Useful resources',
      links: [{
        label: 'Resource center',
        address: RESOURCE_CENTER_CHILDCARE_URL
      }, {
        label: 'Nanny tax guide',
        address: NTG_URL
      }, {
        label: 'Sample nanny contract',
        address: SNC_URL
      }, {
        label: 'Nanny pay rates',
        address: NPR_URL
      }, {
        label: 'State tax & payroll laws',
        address: STATETAX_URL
      }, {
        label: 'Nanny tax calculator',
        address: "".concat(HOMEPAY_URL).concat(constants/* ROUTING_PROPERTIES.nannyTaxCalculator.relativeURL */.ZY.nannyTaxCalculator.relativeURL)
      }]
    }, {
      groupTitle: 'Contact us',
      links: [{
        label: "Call toll-free ".concat(constants/* PHONE_LABEL */.el),
        address: constants/* PHONE_LINK */.v
      }, {
        label: 'Mon - Thurs: 8am - 6pm CT',
        address: '#'
      }, {
        label: 'Fri: 8am - 5pm CT',
        address: '#'
      }, {
        label: "Email: ".concat(constants/* HP_EMAIL */.V),
        address: "mailto:".concat(constants/* HP_EMAIL */.V)
      }]
    }]
  });
};

/* harmony default export */ var Footer_Footer = (Footer);
;// CONCATENATED MODULE: ./src/components/Layout/Footer/index.ts


/***/ }),

/***/ 29732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Header_Header; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/ramda/es/head.js + 1 modules
var head = __webpack_require__(54506);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/@care/navigation/dist/components/HomePayVisitorHeader/HomePayVisitorHeader.js + 9 modules
var HomePayVisitorHeader = __webpack_require__(43430);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/IconLogoHomepaylogo.js
var IconLogoHomepaylogo = __webpack_require__(20074);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(18459);
// EXTERNAL MODULE: ./src/components/UserProvider/index.ts + 1 modules
var UserProvider = __webpack_require__(44979);
// EXTERNAL MODULE: ./src/utils/AnalyticsHelper.ts
var AnalyticsHelper = __webpack_require__(10239);
// EXTERNAL MODULE: ./src/utils/urlHelper.ts
var urlHelper = __webpack_require__(20253);
// EXTERNAL MODULE: ./src/utils/usePartnerInfo.ts + 1 modules
var usePartnerInfo = __webpack_require__(5815);
// EXTERNAL MODULE: ./src/components/contexts/FeatureFlagsContext.tsx
var FeatureFlagsContext = __webpack_require__(45410);
// EXTERNAL MODULE: ./src/utils/hooks.ts
var hooks = __webpack_require__(18546);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Layout/Header/Header.tsx















var _ref = config_default()(),
    publicRuntimeConfig = _ref.publicRuntimeConfig;

var AUTH_LOGOUT_URL = publicRuntimeConfig.AUTH_LOGOUT_URL,
    BREEDLOVE_LOGIN_URL = publicRuntimeConfig.BREEDLOVE_LOGIN_URL,
    HOMEPAY_URL = publicRuntimeConfig.HOMEPAY_URL,
    CORE_BASE_URL = publicRuntimeConfig.CORE_BASE_URL;

var Header = function Header(_ref2) {
  var _flags$CLIENT_FEATURE, _flags$CLIENT_FEATURE2;

  var isMobile = _ref2.isMobile,
      branding = _ref2.branding,
      leftLinks = _ref2.leftLinks,
      pageProperties = _ref2.pageProperties,
      hidePhone = _ref2.hidePhone;

  var _useUserAuth = (0,UserProvider/* useUserAuth */.Ii)(),
      auth = _useUserAuth.auth;

  var partnerInfo = (0,usePartnerInfo/* default */.Z)();

  var _useFeatureFlags = (0,FeatureFlagsContext/* useFeatureFlags */.g)(),
      flags = _useFeatureFlags.flags;

  var logoUrl = (_flags$CLIENT_FEATURE = (_flags$CLIENT_FEATURE2 = flags[constants/* CLIENT_FEATURE_FLAGS.TTP_ASSET_URL */.Pq.TTP_ASSET_URL]) === null || _flags$CLIENT_FEATURE2 === void 0 ? void 0 : _flags$CLIENT_FEATURE2.value) !== null && _flags$CLIENT_FEATURE !== void 0 ? _flags$CLIENT_FEATURE : "".concat(CORE_BASE_URL, "/s/d/ttp/care-logo.svg");
  var leftSideLinks = (0,hooks/* useGetHeaderLeftSideLinks */.PG)(isMobile, publicRuntimeConfig, leftLinks);

  var handleLoginClick = function handleLoginClick() {
    (0,AnalyticsHelper/* logAnalyticsEvent */.qw)({
      data: {
        cta_location: 'Header',
        cta_text: 'LogIn'
      },
      name: AnalyticsHelper/* AmplitudeEventName.ctaInteracted */.LW.ctaInteracted,
      pageProperties
    });
    globalThis.location.assign(BREEDLOVE_LOGIN_URL);
  };

  var handleGetStarted = function handleGetStarted() {
    (0,AnalyticsHelper/* logAnalyticsEvent */.qw)({
      data: {
        cta_location: 'Header',
        cta_text: 'GetStarted'
      },
      name: AnalyticsHelper/* AmplitudeEventName.ctaInteracted */.LW.ctaInteracted,
      pageProperties
    });
    globalThis.location.assign((0,urlHelper/* getEnrollmentUrl */.JD)(undefined, undefined, partnerInfo === null || partnerInfo === void 0 ? void 0 : partnerInfo.name));
  };

  var handleLogoutClick = function handleLogoutClick() {
    (0,AnalyticsHelper/* logAnalyticsEvent */.qw)({
      data: {
        cta_location: 'Header',
        cta_text: 'logout (menu)'
      },
      name: AnalyticsHelper/* AmplitudeEventName.ctaInteracted */.LW.ctaInteracted,
      pageProperties
    });
    var redirectUri = encodeURIComponent("".concat(globalThis.location.origin, "/homepay"));
    globalThis.location.assign("".concat(AUTH_LOGOUT_URL, "?returnUrl=").concat(redirectUri));
  };

  var getAuthLinks = function getAuthLinks() {
    if (auth !== null && auth !== void 0 && auth.isLoggedIn && auth !== null && auth !== void 0 && auth.member) {
      var _auth$member = auth.member,
          displayName = _auth$member.displayName,
          firstName = _auth$member.firstName,
          lastName = _auth$member.lastName;
      var name = firstName && lastName ? "".concat(firstName, " ").concat((0,head/* default */.Z)(lastName)) : displayName;
      return [{
        text: "Hi, ".concat(name),
        type: 'text'
      }, {
        href: '#',
        text: 'Log Out',
        type: 'link',
        onClick: handleLogoutClick
      }];
    }

    if (isMobile) {
      return [{
        href: '#',
        variant: 'contained',
        color: 'secondary',
        text: 'Log In',
        type: 'button',
        onClick: handleLoginClick
      }];
    }

    return [{
      href: '#',
      text: 'Log In',
      type: 'link',
      onClick: handleLoginClick
    }];
  };

  var brandLink = branding !== null && branding !== void 0 ? branding : {
    href: "".concat(HOMEPAY_URL).concat(constants/* ROUTING_PROPERTIES.mainVHP.relativeURL */.ZY.mainVHP.relativeURL),
    logo: /*#__PURE__*/(0,jsx_runtime.jsx)(IconLogoHomepaylogo/* default */.Z, {
      height: "58px",
      width: "200px"
    })
  };
  var rightSideLinks = [{
    text: constants/* PHONE_LABEL */.el,
    href: constants/* PHONE_LINK */.v,
    type: 'link',
    color: 'initial'
  }].concat((0,toConsumableArray/* default */.Z)(getAuthLinks()));

  if (hidePhone) {
    rightSideLinks.shift();
  }

  return isMobile ? /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
    sx: {
      '& .MuiGrid-root': {
        '@media (max-width: 425px)': {
          width: 250
        }
      }
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(HomePayVisitorHeader/* default */.Z, {
      branding: brandLink,
      isMobile: true,
      leftLinks: leftSideLinks,
      altLogoUrl: logoUrl,
      rightLinks: rightSideLinks,
      hasNoGetStartedCTA: true
    })
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(HomePayVisitorHeader/* default */.Z, {
    branding: brandLink,
    isMobile: false,
    leftLinks: leftSideLinks,
    altLogoUrl: logoUrl,
    rightLinks: rightSideLinks,
    onGetStartedClick: handleGetStarted
  });
};

/* harmony default export */ var Header_Header = (Header);
;// CONCATENATED MODULE: ./src/components/Layout/Header/index.ts


/***/ }),

/***/ 35699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Layout_Layout; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/@care/material-ui-theme/dist/config/theme/theme.js + 68 modules
var theme = __webpack_require__(5136);
// EXTERNAL MODULE: ./src/utils/AnalyticsHelper.ts
var AnalyticsHelper = __webpack_require__(10239);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(18459);
// EXTERNAL MODULE: ./src/components/Layout/Header/index.ts + 1 modules
var Header = __webpack_require__(29732);
// EXTERNAL MODULE: ./src/components/Layout/Footer/index.ts + 1 modules
var Footer = __webpack_require__(29192);
// EXTERNAL MODULE: ./src/components/contexts/FeatureFlagsContext.tsx
var FeatureFlagsContext = __webpack_require__(45410);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Layout/Layout.tsx


var _excluded = ["FooterComponent", "HeaderComponent", "children", "hasContainer", "hasFooterInContainer", "banner", "isMobile", "meta", "pageProperties", "skipScreenViewed"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var _ref = config_default()(),
    publicRuntimeConfig = _ref.publicRuntimeConfig;

var CORE_BASE_URL = publicRuntimeConfig.CORE_BASE_URL,
    HOMEPAY_URL = publicRuntimeConfig.HOMEPAY_URL;

function getMeta(meta, favIconUrl) {
  var canonical = typeof meta.relativeCanonical === 'undefined' ? meta.relativeCanonical : "".concat(HOMEPAY_URL).concat(meta.relativeCanonical);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
      children: meta.title
    }), canonical && /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      href: canonical,
      rel: "canonical"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      href: canonical,
      hrefLang: "en-US",
      rel: "alternate"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      href: favIconUrl,
      rel: "shortcut icon"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      href: "".concat(CORE_BASE_URL, "/img/care-no-tag.jpg"),
      rel: "image_src"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      charSet: "utf-8"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      content: "width=device-width, initial-scale=1.0",
      name: "viewport"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      content: "IE=edge,chrome=1",
      httpEquiv: "X-UA-Compatible"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      content: "zz15lR180u9eCqTfur/9l+bMP75AampYtDEm6OnbkWY=",
      name: "verify-v1"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      content: "".concat(CORE_BASE_URL, "/img/care-no-tag.jpg"),
      name: "og:image"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      content: "6030284861",
      name: "fb:page_id"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      content: meta.description,
      name: "description"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      content: meta.keywords,
      name: "keywords"
    })]
  });
}

var Layout = function Layout(_ref2) {
  var _flags$CLIENT_FEATURE, _flags$CLIENT_FEATURE2;

  var FooterComponent = _ref2.FooterComponent,
      HeaderComponent = _ref2.HeaderComponent,
      children = _ref2.children,
      _ref2$hasContainer = _ref2.hasContainer,
      hasContainer = _ref2$hasContainer === void 0 ? true : _ref2$hasContainer,
      _ref2$hasFooterInCont = _ref2.hasFooterInContainer,
      hasFooterInContainer = _ref2$hasFooterInCont === void 0 ? false : _ref2$hasFooterInCont,
      banner = _ref2.banner,
      isMobile = _ref2.isMobile,
      meta = _ref2.meta,
      pageProperties = _ref2.pageProperties,
      _ref2$skipScreenViewe = _ref2.skipScreenViewed,
      skipScreenViewed = _ref2$skipScreenViewe === void 0 ? false : _ref2$skipScreenViewe,
      containerProps = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);

  var isMobileDefault = (0,useMediaQuery/* default */.Z)('(max-width: 1155px)');
  var isMobileActual = isMobile !== null && isMobile !== void 0 ? isMobile : isMobileDefault;
  var ActualFooter = FooterComponent !== null && FooterComponent !== void 0 ? FooterComponent : Footer/* default */.Z;
  var ActualHeader = HeaderComponent !== null && HeaderComponent !== void 0 ? HeaderComponent : Header/* default */.Z;

  var _useFeatureFlags = (0,FeatureFlagsContext/* useFeatureFlags */.g)(),
      flags = _useFeatureFlags.flags;

  var favIconUrl = "".concat(CORE_BASE_URL).concat((_flags$CLIENT_FEATURE = (_flags$CLIENT_FEATURE2 = flags[constants/* CLIENT_FEATURE_FLAGS.TTP_FAVICON_URL */.Pq.TTP_FAVICON_URL]) === null || _flags$CLIENT_FEATURE2 === void 0 ? void 0 : _flags$CLIENT_FEATURE2.value) !== null && _flags$CLIENT_FEATURE !== void 0 ? _flags$CLIENT_FEATURE : '/img/crcm-favicon.ico');
  (0,react.useEffect)(function () {
    if (!skipScreenViewed) {
      (0,AnalyticsHelper/* logAnalyticsEvent */.qw)({
        name: AnalyticsHelper/* AmplitudeEventName.screenViewed */.LW.screenViewed,
        pageProperties
      });
    }
  }, [skipScreenViewed, pageProperties]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: getMeta(meta, favIconUrl)
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      position: "relative",
      zIndex: 999,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ActualHeader, {
        isMobile: isMobileActual,
        pageProperties: pageProperties
      })
    }), hasContainer ? /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
      sx: {
        [theme/* theme.breakpoints.up */.rS.breakpoints.up('md')]: {
          paddingTop: theme/* theme.spacing */.rS.spacing(13 + 0.2)
        },
        [theme/* theme.breakpoints.down */.rS.breakpoints.down('md')]: {
          paddingTop: theme/* theme.spacing */.rS.spacing(7 + 0.2)
        }
      },
      children: [banner !== null && banner !== void 0 ? banner : null, /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, _objectSpread(_objectSpread({
        maxWidth: "xl"
      }, containerProps), {}, {
        children: children
      }))]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* default */.Z, {
      pt: 7,
      sx: {
        [theme/* theme.breakpoints.up */.rS.breakpoints.up('md')]: {
          paddingTop: theme/* theme.spacing */.rS.spacing(13 + 0.2)
        },
        [theme/* theme.breakpoints.down */.rS.breakpoints.down('md')]: {
          paddingTop: theme/* theme.spacing */.rS.spacing(7 + 0.2)
        }
      },
      children: [banner !== null && banner !== void 0 ? banner : null, children]
    }), hasFooterInContainer ? /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, _objectSpread(_objectSpread({
      maxWidth: "xl"
    }, containerProps), {}, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ActualFooter, {
        isMobile: isMobile
      })
    })) : /*#__PURE__*/(0,jsx_runtime.jsx)(ActualFooter, {
      isMobile: isMobile
    })]
  });
};

/* harmony default export */ var Layout_Layout = (Layout);
;// CONCATENATED MODULE: ./src/components/Layout/index.ts


/***/ }),

/***/ 18546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lh": function() { return /* binding */ useMobileQuery; },
/* harmony export */   "PG": function() { return /* binding */ useGetHeaderLeftSideLinks; },
/* harmony export */   "ZO": function() { return /* binding */ useMediaSameAndDown; }
/* harmony export */ });
/* unused harmony export useMediaSameAndUp */
/* harmony import */ var _care_material_ui_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5136);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18459);




var useMobileQuery = function useMobileQuery() {
  return (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_care_material_ui_theme__WEBPACK_IMPORTED_MODULE_3__/* .theme.breakpoints.down */ .rS.breakpoints.down('md'));
};
var useMediaSameAndDown = function useMediaSameAndDown(breakpoint) {
  return (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_care_material_ui_theme__WEBPACK_IMPORTED_MODULE_3__/* .theme.breakpoints.down */ .rS.breakpoints.down(breakpoint));
};
var useMediaSameAndUp = function useMediaSameAndUp(breakpoint) {
  return useMuiMediaQuery(theme.breakpoints.up(breakpoint));
};
var useGetHeaderLeftSideLinks = function useGetHeaderLeftSideLinks(isMobile, publicRuntimeConfig, leftLinks) {
  var HOMEPAY_URL = publicRuntimeConfig.HOMEPAY_URL,
      RESOURCE_CENTER_URL = publicRuntimeConfig.RESOURCE_CENTER_URL,
      FOR_PARTNERS_URL = publicRuntimeConfig.FOR_PARTNERS_URL;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      leftSideLinks = _useState[0],
      setLeftSideLinks = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setLeftSideLinks(leftLinks !== null && leftLinks !== void 0 ? leftLinks : [{
      text: 'Home',
      href: "".concat(HOMEPAY_URL).concat(_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTING_PROPERTIES.mainVHP.relativeURL */ .ZY.mainVHP.relativeURL),
      type: 'link',
      isVisible: isMobile
    }, {
      text: 'Service & Pricing',
      href: "".concat(HOMEPAY_URL).concat(_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTING_PROPERTIES.productAndPricing.relativeURL */ .ZY.productAndPricing.relativeURL),
      type: 'link'
    }, {
      text: 'Resource Center',
      href: RESOURCE_CENTER_URL,
      type: 'link'
    }, {
      text: 'For Caregivers',
      href: "".concat(HOMEPAY_URL).concat(_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTING_PROPERTIES.caregiver.relativeURL */ .ZY.caregiver.relativeURL),
      type: 'link'
    }, {
      text: 'For Partners',
      href: FOR_PARTNERS_URL,
      type: 'link'
    }, {
      text: 'ProPortal',
      href: "".concat(HOMEPAY_URL).concat(_constants__WEBPACK_IMPORTED_MODULE_1__/* .ROUTING_PROPERTIES.proPortal.relativeURL */ .ZY.proPortal.relativeURL),
      type: 'link'
    }]);
  }, [leftLinks, isMobile, HOMEPAY_URL, RESOURCE_CENTER_URL, FOR_PARTNERS_URL]);
  return leftSideLinks;
};

/***/ }),

/***/ 5815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ usePartnerInfo; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(73359);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/ramda/es/head.js + 1 modules
var head = __webpack_require__(54506);
// EXTERNAL MODULE: ./src/API/partners.ts
var partners = __webpack_require__(48198);
// EXTERNAL MODULE: ./node_modules/universal-cookie/es6/index.js + 2 modules
var es6 = __webpack_require__(65885);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(18459);
;// CONCATENATED MODULE: ./src/utils/setPromoCodeCookie.ts




var _ref = config_default()(),
    publicRuntimeConfig = _ref.publicRuntimeConfig;

var CORE_BASE_URL = publicRuntimeConfig.CORE_BASE_URL;
/* harmony default export */ var setPromoCodeCookie = (function (promoCode) {
  var cookies = new es6/* default */.Z();
  var curCookie = cookies.get(constants/* HOMEPAY_PROMO_CODE_COOKIE */.Ek);

  if (curCookie === null || curCookie === undefined) {
    var maxAge = 31 * 24 * 60 * 60;
    var path = '/';
    var domain = CORE_BASE_URL.replace(/^https?:\/\//, '').replace('www.', '');
    var expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + maxAge * 1000);
    cookies.set(constants/* HOMEPAY_PROMO_CODE_COOKIE */.Ek, promoCode, {
      expires: expirationDate,
      maxAge,
      path,
      domain
    });
  }
});
;// CONCATENATED MODULE: ./src/utils/usePartnerInfo.ts







/* harmony default export */ var usePartnerInfo = (function () {
  var _useLazyQuery = (0,useLazyQuery/* useLazyQuery */.t)(partners/* CO_BRANDED_PARTNER_INFORMATION */.m),
      _useLazyQuery2 = (0,slicedToArray/* default */.Z)(_useLazyQuery, 2),
      fetchPartnerInfo = _useLazyQuery2[0],
      data = _useLazyQuery2[1].data;

  var router = (0,next_router.useRouter)();
  var partnerInfo = data === null || data === void 0 ? void 0 : data.coBrandedPartnerInformation;
  (0,react.useEffect)(function () {
    if (router !== null && router !== void 0 && router.query.marketingPath) {
      fetchPartnerInfo({
        variables: {
          input: {
            marketingPath: (0,head/* default */.Z)(router === null || router === void 0 ? void 0 : router.query.marketingPath)
          }
        }
      });
    }
  }, [router === null || router === void 0 ? void 0 : router.query, fetchPartnerInfo]);
  (0,react.useEffect)(function () {
    var _errors;

    if (partnerInfo && partnerInfo.name) {
      setPromoCodeCookie('BDFREEMONTH');
    }

    if ((partnerInfo === null || partnerInfo === void 0 ? void 0 : (_errors = partnerInfo.errors) === null || _errors === void 0 ? void 0 : _errors[0].message) === '/: Marketing path was not found.') {
      router === null || router === void 0 ? void 0 : router.replace('/404');
    }
  }, [partnerInfo, router, router === null || router === void 0 ? void 0 : router.replace]);
  return partnerInfo;
});

/***/ })

}]);